// Add hook here that calls /search-service/v2/search with req.body.query as the plain text query

import { useQuery } from "@tanstack/react-query";
import { useQueryKeySpecificity } from "hooks/useQueryKeyAuth";
import queryKeys from "queries/keys";
import { search } from "services/searchServiceService";
import { useRootStore } from "store";

export const useSearchV3 = (query: string) => {
  const {
    authStore: auth,
    userStore: { isAdmin },
  } = useRootStore();
  const specificity = useQueryKeySpecificity({ query });

  const { queryKey } = queryKeys.searchService.search(specificity);

  return useQuery({
    queryKey,
    queryFn: () => search({ query }, auth),
    enabled: !!query && auth.isLoggedIn && isAdmin,
  });
};
